module.exports = __webpack_public_path__ + "580d0778ad254335be45bf58bb449f43.ttf";